<template>
    <div class="admin">
        <h2>Admin</h2>
        <div>{{ syncmsg }}</div><br>
         <button class="mui-btn mui-btn--raised" v-on:click="syncData()">Sync Data</button>
        <div>{{ connmsg }}</div><br>
        <table class="mui-table mui-table--bordered">
            <thead>
                <tr>
                    <th>ID</th>
                    <th>User</th>
                    <th>Role</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody v-for="user in users" :key="user.id">
                <tr>
                    <td>{{ user.id }}</td>
                    <td>{{ user.user }}</td>
                    <td>{{ user.role }}</td>
                    <td>
                        <button class="mui-btn mui-btn--raised" v-on:click="deleteUser(user.id)">Delete</button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div>{{ deletemsg }}</div><br>
        <form class="mui-form" v-on:submit.prevent="createUser">
            <legend>Create User</legend>
            <div class="mui-textfield">
                <input v-model.trim="user" name="user" type="text" placeholder="Name">
            </div>
            <div class="mui-textfield">
                <input v-model.trim="password" name="password" type="password" placeholder="Password">
            </div>
            <div class="mui-select">
                <select v-model="role">
                    <option>viewer</option>
                    <option>admin</option>
                </select>
                <label>Role</label>
            </div>
            <div>{{ createmsg }}</div><br>
            <button type="submit" class="mui-btn mui-btn--raised">Submit</button>
        </form>
    </div>
</template>

<script>
import router from '@/router'
import store from '@/store'

export default {
    name: 'admin',
    data() {
        return {
            user: '',
            password: '',
            role: 'viewer',
            syncmsg: '',
            connmsg: '',
            createmsg: '',
            deletemsg: '',
            users: ''
        }
    },
    beforeCreate() {
        if (!store.state.isLogged || !store.state.admin) {
            router.push('/')
        }
    },
    created() {
        this.getUsers()
    },
    methods: {
        syncData() {
            this.axios.get('sync')
                .then((response) => {
                    this.syncmsg = response.data.status
                }, () => {
                    this.syncmsg = 'Error: Could not reach server!'
                })
        },
        getUsers() {
            this.axios.get('getuser')
                .then((response) => {
                    this.users = response.data
                }, () => {
                    this.connmsg = 'Error: Could not reach server!'
                })
        },
        createUser() {
            this.axios.post('insertuser', {
                user: this.user,
                password: this.password,
                role: this.role
            }).then((response) => {
                this.createmsg = response.data.status
                this.getUsers()
            }, () => {
                this.connmsg = 'Error: Could not reach server!'
            })
        },
        deleteUser(id) {
            this.axios.delete('deleteuser', { params: { id: id } })
                .then((response) => {
                    this.deletemsg = response.data.status
                    this.getUsers()
                }, () => {
                    this.connmsg = 'Error: Could not reach server!'
                })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Admin.vue?f57d652a